import dayjs from 'dayjs';
import { ValidationParameters } from '../types/Validation';

/**
 * An object of methods we can map our validation items
 * to. These will just return booleans (valid [true] or not valid [false]).
 */
export default {

  /**
   * Check if a field has a value when required.
   */
  required: (params: ValidationParameters): boolean => {
    const { content } = params;

    if (Array.isArray(content)) {
      return content.length > 0;
    }

    return !!(content !== null && content !== '' && content !== undefined);
  },

  /**
   * Check a field does not exceed a maximum length.
   */
  maxLength: (params: ValidationParameters):
    boolean => params.content.length < params.validation.value,

  /**
   * Check a field is at least a minimum length.
   */
  minLength: (params: ValidationParameters):
    boolean => params.content.length >= params.validation.value,

  /**
   * Check a field does not exceed a maximum value (Number).
   */
  maxValue: (params: ValidationParameters):
    boolean => (Number(params.content) <= Number(params.validation.value)),

  /**
   * Check a field is at least a minimum value (Number).
   */
  minValue: (params: ValidationParameters):
    boolean => (Number(params.content) >= Number(params.validation.value)),

  /**
   * Check a field is not after a minimum value (Date).
   */
  maxDate: (params: ValidationParameters):
    boolean => dayjs(params.content).isBefore(params.validation.value),

  /**
   * Check a field is not before a minimum value (Date).
   */
  minDate: (params: ValidationParameters):
    boolean => dayjs(params.content).isAfter(params.validation.value),
};
